<!-- Set the expireMOTD below, and change the text in the template -->

<template>
   <v-dialog
      v-model="showMOTD"
      v-if="calcShow"

      max-width="700"
    >
      <v-card :class="!$vuetify.breakpoint.xsOnly ? 'px-4 py-4' : ''">
        <!-- <v-card-title class="headline">ARCHIBUS Decommission</v-card-title> -->
        <v-card-title class="headline">New Feature - Building Managers</v-card-title>

        <v-card-text>
          Building Managers has been added to the bottom of the Building Card.  After selecting a building, look toward the bottom for the <v-icon>people</v-icon> icon.
        </v-card-text>

        <!-- <v-card-text>
          Interactive Floorplan's map interface has been upgraded!<br><br>  Hopefully you'll find this to be much snappier.  Many changes were made to how the display, pan, zoom, highlight and label functions work.<br><br>
          Please let us know if you experience any problems with the new interface.<br>
          The feedback form is found in the Main Menu.

        </v-card-text> -->

<!--         <v-card-text>
          Room Collections (see main menu) has been updated with many new features.<br><br>
          Room Collections is used to make Collections of rooms.  Each user owns and manages access to the collections they create. Collections can be named and custom colored.<br>

          Collections are organized into Collection Groups<br><br>

          <div class="px-5">
          <v-icon class="mr-2" style="position: relative; top: 3px;">share</v-icon>Collaborate by sending a link or
          assigning Viewers and Editors<br><br>
          <v-icon class="mr-2" style="position: relative; top: 3px;">control_camera</v-icon>Display Collection or Collection Group on map<br><br>
          <v-icon class="mr-2" style="position: relative; top: 3px;">color_lens</v-icon>Change Collection Color<br><br>          
          
          Clone : Copy the Collection or Group and become owner of a new copy<br><br>

          </div>
          
          Collections and Collection Groups can be Re-Ordered<br>
          Collections and Collection Groups can be exported to .xlsx

        </v-card-text> -->
<!--           Interactive Flooplans will become UA system of record on February 28th, 2020.  <br><br>ARCHIBUS will no longer be available. <br><br>UA Space data will be edited by using Interactive Floorplans beginning on this date.
          <br><br>To request edit capability or occupancy update capability, please contact <a href="mailto:jbteran@email.arizona.edu" class="redlink">Jose Teran</a> with Space Planning and Management of Planning, Design & Construction. -->

<!--           Among the commonly used maps this will impact are:
          <p></p>
          <ul>
          <li>UA Public Map</li>
          <li>Arizona Mobile</li>
          <li>Campus 360</li>
          <li><b>Interactive Floorplans</b></li>
          <li>Campus Arboretum Map</li>
          <li>Family Resource Map</li>
          <li>Building The Future</li>
          <li>UA Sustainability Map</li>
          <li>REST Services at  https://services.maps.arizona.edu</li>
          </ul> -->

        <v-card-actions>
          <v-layout justify-space-between>

          <v-btn color="green darken-1" flat="flat" @click="doNotShow()">
              DO NOT SHOW AGAIN
          </v-btn>
          <v-btn color="green darken-1" flat="flat" @click="clickHandler()">
              OK
          </v-btn>
          </v-layout>

        </v-card-actions>
      </v-card>
    </v-dialog>

</template>

<script>
import Vuex from 'vuex'
import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
        showMOTD: true,       // yyyy-mm-dd  
        expireMOTD: new Date('2024-10-10T00:00:00')
    }
  },

  computed : {
    ...mapGetters(['ignoreMOTDDate']),

    calcShow: function () {
      // Is ignoreMOTDDate set to ignore this expireMOTD?
      if (this.ignoreMOTDDate && this.ignoreMOTDDate == this.expireMOTD) {
        return false
      }

      // If today is less than expiration, SHOW.
      if (new Date() < this.expireMOTD) {
        return true
      }


      
    }
  },

  methods : {
    ...mapActions(['setIgnoreMOTDDate']),

    clickHandler : function () {
      this.showMOTD = false; 
    },

    doNotShow: function () {
      this.setIgnoreMOTDDate(this.expireMOTD)  // Ignore any MOTD that has an expiration of this date.
      this.showMOTD = false;
    },

  },
}

</script>


<style>
.redlink {
    display: inline-block;
    color: #ab0520;
    font-weight: 600;
}

</style>



// WEBPACK FOOTER //
// src/components/MOTD.vue